<template>
  <div class="tx-Taxons_ListItem">
    <a :href="link" :class="{ 'tx-Taxons_Link-removable': active, 'tx-Taxons_Link': !active }">
      <span class="d-flex justify-content-start text-truncate">
        <span class="text-truncate">{{ name }}</span>
      </span>
      <span v-if="active">
        <Close class="svg-fill-dark svg-16" />
      </span>
      <span v-else-if="count" class="tx-Taxons_Count">{{ count }}</span>
    </a>
  </div>
</template>

<script>
import Close from "../../icons/atalanda/close.svg";

export default {
  name: "FilterItem",
  components: {
    Close,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    count: {
      type: [String, Number],
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
